import { FormO2MFieldSelectWidget, ModelFieldType, SPI, ViewType, Widget } from '@kunlun/dependencies';

@SPI.ClassFactory(
  FormO2MFieldSelectWidget.Token({
    viewType: [ViewType.Form, ViewType.Search],
    ttype: ModelFieldType.OneToMany,
    widget: 'selectMaxTagCountForm',
    name: 'salesOffices',
    model: 'deli.aries.major.platform.DeliAriesPlatformBrandStore'
  })
)
export class FormO2mMultiSelectMaxTagCountFormFieldWidget extends FormO2MFieldSelectWidget {
  @Widget.Reactive()
  public get maxTagCount() {
    return 2
  }

  @Widget.Watch('formData.id', { deep: true, immediate: true })
  private watchId(id: string) {
    this.field.domain = `dataStatus=='ENABLED' and (${id ? `brandStoreId=='${id}' or` : ''} brandStoreId=isnull=true)`;
  }
  
  protected search(searchValue: string, forceSearch?: boolean | undefined): Promise<void> {
    this.setQueryFieldName('code,displayName')
    super.search(searchValue)
    return new Promise(resolve => resolve());
  }

  initialize(props) {
    super.initialize(props);
    return this;
  }
}